/*
 * MSCVTR wizard - optiedata per pak (voering, knopen, zakken, bandplooi, broekafwerking + vrije tekst).
 * AUTOMATISCH GEGENEREERD uit de bestaande Globo-config (eenmalige export).
 * Colbert-/pantalonmaten en de maatcalculator staan NIET hier - die zijn centraal in mscvtr-wizard.js.
 *
 * NIEUW PAK TOEVOEGEN:
 *   1. Voeg een sleutel toe met de product-handle (zie URL /products/<handle>).
 *   2. Vul title + price (euro's) in.
 *   3. Voeg per optiegroep een swatchStep toe: { key, label, required, values:[{label, code, image}] }.
 *      - label  = wat de klant ziet (bv. "Sky Blue Satin")
 *      - code   = productiecode voor Pascal (bv. "DB_S21"); mag null zijn
 *      - image  = volledige URL naar de swatch (Shopify Files), of null voor een tekstknop
 *   4. textSteps zijn optioneel (vrije tekstvelden).
 * De wizard werkt automatisch met wat hier staat; niets in de code hoeft te wijzigen.
 */
window.MSCVTR_SUIT_OPTIONS = {
  "tuscany-navy-blue-banda-suit": {
    "title": "Tuscany Navy Blue Banda Suit",
    "price": 789,
    "swatchSteps": [
      {
        "key": "voering",
        "label": "Voering",
        "required": true,
        "values": [
          {
            "label": "Sky Blue Satin",
            "code": "DB_S21",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17745947819839.png"
          },
          {
            "label": "Midnight Navy",
            "code": "DB_S18",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17745947854375.png"
          },
          {
            "label": "Navy Houndstooth",
            "code": "2927",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17745947883494.png"
          }
        ]
      },
      {
        "key": "knopen",
        "label": "Knopen",
        "required": true,
        "values": [
          {
            "label": "Midnight Classic",
            "code": "F311",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17745948177875.png"
          },
          {
            "label": "Deep Navy Pearl",
            "code": "154",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17745948201333.png"
          },
          {
            "label": "Galaxy Blue",
            "code": "T110",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17745948227146.png"
          }
        ]
      },
      {
        "key": "zakken",
        "label": "Zakken",
        "required": true,
        "values": [
          {
            "label": "Klep recht",
            "code": "A",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17739966384650.png"
          },
          {
            "label": "Klep schuin",
            "code": "B",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17739966419194.png"
          },
          {
            "label": "Klep sterk schuin",
            "code": "D",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17739966447112.png"
          },
          {
            "label": "Recht ingezette zak",
            "code": "D1",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17739966484402.png"
          }
        ]
      },
      {
        "key": "bandplooi",
        "label": "Bandplooi",
        "required": true,
        "values": [
          {
            "label": "Zonder bandplooi",
            "code": null,
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17788488009001.png"
          },
          {
            "label": "Met bandplooi",
            "code": null,
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17788487835460.png"
          }
        ]
      },
      {
        "key": "broekafwerking",
        "label": "Broekafwerking",
        "required": true,
        "values": [
          {
            "label": "Pantalon met rechte zoom",
            "code": null,
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17786894248797.png"
          },
          {
            "label": "Pantalon met omslagzoom",
            "code": null,
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17786894288943.png"
          }
        ]
      }
    ],
    "textSteps": [
      {
        "key": "aanvullende_wensen_colbert",
        "label": "Aanvullende wensen colbert"
      },
      {
        "key": "aanvullende_wensen_pantalon",
        "label": "Aanvullende wensen pantalon"
      }
    ]
  },
  "tuscany-sand-suit": {
    "title": "Tuscany Sand Suit",
    "price": 789,
    "swatchSteps": [
      {
        "key": "voering",
        "label": "Voering",
        "required": true,
        "values": [
          {
            "label": "Florence Bloom",
            "code": "1358/1",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17737587204356.png"
          },
          {
            "label": "Milano Paisley",
            "code": "DBL254",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17737587272247.png"
          },
          {
            "label": "Ivory Essential",
            "code": "11",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17737587322446.png"
          }
        ]
      },
      {
        "key": "knopen",
        "label": "Knopen",
        "required": true,
        "values": [
          {
            "label": "Ivory Classic",
            "code": "B54",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17737587733327.png"
          },
          {
            "label": "Midnight Pearl",
            "code": "MOP",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17737587908135.png"
          },
          {
            "label": "Blush Pearl",
            "code": "NAT",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17737587981176.png"
          }
        ]
      },
      {
        "key": "zakken",
        "label": "Zakken",
        "required": true,
        "values": [
          {
            "label": "Zonder zijzakken",
            "code": "A",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17739966360322.png"
          },
          {
            "label": "Klep recht",
            "code": "B",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17739966384650.png"
          },
          {
            "label": "Klep schuin",
            "code": "C",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17739966419194.png"
          },
          {
            "label": "Klep sterk schuin",
            "code": "D1",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17739966447112.png"
          }
        ]
      },
      {
        "key": "bandplooi",
        "label": "Bandplooi",
        "required": true,
        "values": [
          {
            "label": "Zonder bandplooi",
            "code": null,
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17788488009001.png"
          },
          {
            "label": "Met bandplooi",
            "code": null,
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17788487835460.png"
          }
        ]
      },
      {
        "key": "broekafwerking",
        "label": "Broekafwerking",
        "required": true,
        "values": [
          {
            "label": "Pantalon met rechte zoom",
            "code": null,
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17786893423730.png"
          },
          {
            "label": "Pantalon met omslagzoom",
            "code": null,
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17786893462092.png"
          }
        ]
      }
    ],
    "textSteps": [
      {
        "key": "aanvullende_wensen_colbert",
        "label": "Aanvullende wensen colbert"
      },
      {
        "key": "aanvullende_wensen_pantalon",
        "label": "Aanvullende wensen pantalon"
      }
    ]
  },
  "tuscany-sand-banda-suit": {
    "title": "Tuscany Sand Banda Suit",
    "price": 789,
    "swatchSteps": [
      {
        "key": "voering",
        "label": "Voering",
        "required": true,
        "values": [
          {
            "label": "Silver Grey Satin",
            "code": "DB_S4",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17745951625990.png"
          },
          {
            "label": "Ivory Essential",
            "code": "11",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17737587322446.png"
          },
          {
            "label": "Champagne Satin",
            "code": "P4037",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17745951687707.png"
          }
        ]
      },
      {
        "key": "knopen",
        "label": "Knopen",
        "required": true,
        "values": [
          {
            "label": "Dark Walnut Gloss",
            "code": "MP58",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17745951893552.png"
          },
          {
            "label": "Ivory Classic",
            "code": "NAT",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17737587733327.png"
          },
          {
            "label": "Amber Marble",
            "code": "P4037",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17745951913208.png"
          }
        ]
      },
      {
        "key": "zakken",
        "label": "Zakken",
        "required": true,
        "values": [
          {
            "label": "Klep recht",
            "code": "A",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17739966384650.png"
          },
          {
            "label": "Klep schuin",
            "code": "B",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17739966419194.png"
          },
          {
            "label": "Klep sterk schuin",
            "code": "C",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17739966447112.png"
          },
          {
            "label": "Recht ingezette zak",
            "code": "D1",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17739966484402.png"
          }
        ]
      },
      {
        "key": "bandplooi",
        "label": "Bandplooi",
        "required": true,
        "values": [
          {
            "label": "Zonder bandplooi",
            "code": null,
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17788488009001.png"
          },
          {
            "label": "Met bandplooi",
            "code": null,
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17788487835460.png"
          }
        ]
      },
      {
        "key": "broekafwerking",
        "label": "Broekafwerking",
        "required": true,
        "values": [
          {
            "label": "Pantalon met rechte zoom",
            "code": null,
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17786892337350.png"
          },
          {
            "label": "Pantalon met omslagzoom",
            "code": null,
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17786892373488.png"
          }
        ]
      }
    ],
    "textSteps": [
      {
        "key": "aanvullende_wensen_colbert",
        "label": "Aanvullende wensen colbert"
      },
      {
        "key": "aanvullende_wensen_pantalon",
        "label": "Aanvullende wensen pantalon"
      }
    ]
  },
  "tuscany-royal-blue-suit": {
    "title": "Tuscany Royal Blue Suit",
    "price": 649,
    "swatchSteps": [
      {
        "key": "voering",
        "label": "Voering",
        "required": true,
        "values": [
          {
            "label": "Sky Blue Satin",
            "code": "DB_S21",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17745923177612.png"
          },
          {
            "label": "Azure Bloom",
            "code": "1365/1",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17745923216436.png"
          },
          {
            "label": "Ivory Essential",
            "code": "11",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17737587322446.png"
          }
        ]
      },
      {
        "key": "knopen",
        "label": "Knopen",
        "required": true,
        "values": [
          {
            "label": "Midnight Gloss",
            "code": "MP16",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17745924173456.png"
          },
          {
            "label": "Steel Pearl",
            "code": "T107",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17745924216350.png"
          },
          {
            "label": "Ivory Classic",
            "code": "NAT",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17737587733327.png"
          }
        ]
      },
      {
        "key": "zakken",
        "label": "Zakken",
        "required": true,
        "values": [
          {
            "label": "Klep recht",
            "code": "A",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17739966384650.png"
          },
          {
            "label": "Klep schuin",
            "code": "B",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17739966419194.png"
          },
          {
            "label": "Klep sterk schuin",
            "code": "D",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17739966447112.png"
          },
          {
            "label": "Recht ingezette zak",
            "code": "D1",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17739966484402.png"
          }
        ]
      },
      {
        "key": "bandplooi",
        "label": "Bandplooi",
        "required": true,
        "values": [
          {
            "label": "Zonder bandplooi",
            "code": null,
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17788488009001.png"
          },
          {
            "label": "Met bandplooi",
            "code": null,
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17788487835460.png"
          }
        ]
      },
      {
        "key": "broekafwerking",
        "label": "Broekafwerking",
        "required": true,
        "values": [
          {
            "label": "Pantalon met rechte zoom",
            "code": null,
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17786891298519.png"
          },
          {
            "label": "Pantalon met omslagzoom",
            "code": null,
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17786891341005.png"
          }
        ]
      }
    ],
    "textSteps": [
      {
        "key": "aanvullende_wensen_colbert",
        "label": "Aanvullende wensen colbert"
      },
      {
        "key": "aanvullende_wensen_pantalon",
        "label": "Aanvullende wensen pantalon"
      }
    ]
  },
  "tuscany-green-suit": {
    "title": "Tuscany Green Suit",
    "price": 789,
    "swatchSteps": [
      {
        "key": "voering",
        "label": "Voering",
        "required": true,
        "values": [
          {
            "label": "Botanical Bloom",
            "code": "3356/1",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17745942125413.png"
          },
          {
            "label": "Ivory Essential",
            "code": "11",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17737587322446.png"
          },
          {
            "label": "Balloon Festival",
            "code": "2254/1",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17745942085807.png"
          }
        ]
      },
      {
        "key": "knopen",
        "label": "Knopen",
        "required": true,
        "values": [
          {
            "label": "Forest Matte",
            "code": "mfb",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17745943017391.png"
          },
          {
            "label": "Emerald Gloss",
            "code": "157",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17745943031193.png"
          },
          {
            "label": "Ivory Classic",
            "code": "NAT",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17737587733327.png"
          }
        ]
      },
      {
        "key": "zakken",
        "label": "Zakken",
        "required": true,
        "values": [
          {
            "label": "Klep recht",
            "code": "A",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17739966384650.png"
          },
          {
            "label": "Klep schuin",
            "code": "B",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17739966419194.png"
          },
          {
            "label": "Klep sterk schuin",
            "code": "D",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17739966447112.png"
          },
          {
            "label": "Recht ingezette zak",
            "code": "D1",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17739966484402.png"
          }
        ]
      },
      {
        "key": "bandplooi",
        "label": "Bandplooi",
        "required": true,
        "values": [
          {
            "label": "Zonder bandplooi",
            "code": null,
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17788488009001.png"
          },
          {
            "label": "Met bandplooi",
            "code": null,
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17788487835460.png"
          }
        ]
      },
      {
        "key": "broekafwerking",
        "label": "Broekafwerking",
        "required": true,
        "values": [
          {
            "label": "Pantalon met rechte zoom",
            "code": null,
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17786890404277.png"
          },
          {
            "label": "Pantalon met omslagzoom",
            "code": null,
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17786890464010.png"
          }
        ]
      }
    ],
    "textSteps": [
      {
        "key": "aanvullende_wensen_colbert",
        "label": "Aanvullende wensen colbert"
      },
      {
        "key": "aanvullende_wensen_pantalon",
        "label": "Aanvullende wensen pantalon"
      }
    ]
  },
  "tuscany-pink-suit": {
    "title": "Tuscany Pink Suit",
    "price": 789,
    "swatchSteps": [
      {
        "key": "voering",
        "label": "Voering",
        "required": true,
        "values": [
          {
            "label": "Golden Paisley",
            "code": "DBL254",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17745916667808.png"
          },
          {
            "label": "Milano Paisley",
            "code": "1359/1",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17745914996655.png"
          },
          {
            "label": "Ivory Essential",
            "code": "DBL254",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17737587322446.png"
          }
        ]
      },
      {
        "key": "knopen",
        "label": "Knopen",
        "required": true,
        "values": [
          {
            "label": "Old Pink Matte",
            "code": "mfb",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17745918886990.png"
          },
          {
            "label": "Burgundy Gloss",
            "code": "152",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17745917612005.png"
          },
          {
            "label": "Ivory Classic",
            "code": "NAT",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17737587733327.png"
          }
        ]
      },
      {
        "key": "zakken",
        "label": "Zakken",
        "required": true,
        "values": [
          {
            "label": "Klep recht",
            "code": "A",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17739966384650.png"
          },
          {
            "label": "Klep schuin",
            "code": "B",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17739966419194.png"
          },
          {
            "label": "Schuin ingezette zak",
            "code": "D",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17739966549250.png"
          },
          {
            "label": "Sterk schuin ingezette zak",
            "code": "D1",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17739966600520.png"
          }
        ]
      },
      {
        "key": "bandplooi",
        "label": "Bandplooi",
        "required": true,
        "values": [
          {
            "label": "Zonder bandplooi",
            "code": null,
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17788488009001.png"
          },
          {
            "label": "Met bandplooi",
            "code": null,
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17788487835460.png"
          }
        ]
      },
      {
        "key": "broekafwerking",
        "label": "Broekafwerking",
        "required": true,
        "values": [
          {
            "label": "Pantalon met rechte zoom",
            "code": null,
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17786889498641.png"
          },
          {
            "label": "Pantalon met omslagzoom",
            "code": null,
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17786889547446.png"
          }
        ]
      }
    ],
    "textSteps": [
      {
        "key": "aanvullende_wensen_colbert",
        "label": "Aanvullende wensen colbert"
      },
      {
        "key": "aanvullende_wensen_pantalon",
        "label": "Aanvullende wensen pantalon"
      }
    ]
  },
  "tuscany-grigio-banda-suit": {
    "title": "Tuscany Grigio Banda Suit",
    "price": 789,
    "swatchSteps": [
      {
        "key": "voering",
        "label": "Voering",
        "required": true,
        "values": [
          {
            "label": "Light Grey Satin",
            "code": "920",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17745957501732.png"
          },
          {
            "label": "Cool Blue Satin",
            "code": "P4042",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17745957635232.png"
          },
          {
            "label": "Stone Grey Satin",
            "code": "P4004",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17745957668247.png"
          }
        ]
      },
      {
        "key": "knopen",
        "label": "Knopen",
        "required": true,
        "values": [
          {
            "label": "Smoked Grey Pearl",
            "code": "423",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17745958091456.png"
          },
          {
            "label": "Dark Espresso Gloss",
            "code": "F123",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17745958126651.png"
          },
          {
            "label": "Midnight Navy Matte",
            "code": "160",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17745958157915.png"
          }
        ]
      },
      {
        "key": "zakken",
        "label": "Zakken",
        "required": true,
        "values": [
          {
            "label": "Klep recht",
            "code": "A",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17739966384650.png"
          },
          {
            "label": "Klep schuin",
            "code": "B",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17739966419194.png"
          },
          {
            "label": "Klep sterk schuin",
            "code": "D",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17739966447112.png"
          },
          {
            "label": "Recht ingezette zak",
            "code": "D1",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17739966484402.png"
          }
        ]
      },
      {
        "key": "bandplooi",
        "label": "Bandplooi",
        "required": true,
        "values": [
          {
            "label": "Zonder bandplooi",
            "code": null,
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17788488009001.png"
          },
          {
            "label": "Met bandplooi",
            "code": null,
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17788487835460.png"
          }
        ]
      },
      {
        "key": "broekafwerking",
        "label": "Broekafwerking",
        "required": true,
        "values": [
          {
            "label": "Pantalon met rechte zoom",
            "code": null,
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17786888555381.png"
          },
          {
            "label": "Pantalon met omslagzoom",
            "code": null,
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17786888606268.png"
          }
        ]
      }
    ],
    "textSteps": [
      {
        "key": "aanvullende_wensen_colbert",
        "label": "Aanvullende wensen colbert"
      },
      {
        "key": "aanvullende_wensen_pantalon",
        "label": "Aanvullende wensen pantalon"
      }
    ]
  },
  "tuscany-marine-blue-suit": {
    "title": "Tuscany Marine Blue Suit",
    "price": 789,
    "swatchSteps": [
      {
        "key": "voering",
        "label": "Voering",
        "required": true,
        "values": [
          {
            "label": "Sky Blue Satin",
            "code": "DB_S21",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17745947819839.png"
          },
          {
            "label": "Midnight Navy",
            "code": "DB_S18",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17745947854375.png"
          },
          {
            "label": "Navy Houndstooth",
            "code": "2927",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17745947883494.png"
          }
        ]
      },
      {
        "key": "knopen",
        "label": "Knopen",
        "required": true,
        "values": [
          {
            "label": "Midnight Classic",
            "code": "F311",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17745948177875.png"
          },
          {
            "label": "Deep Navy Pearl",
            "code": "154",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17745948201333.png"
          },
          {
            "label": "Galaxy Blue",
            "code": "T110",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17745948227146.png"
          }
        ]
      },
      {
        "key": "zakken",
        "label": "Zakken",
        "required": true,
        "values": [
          {
            "label": "Klep recht",
            "code": "A",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17739966384650.png"
          },
          {
            "label": "Klep schuin",
            "code": "B",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17739966419194.png"
          },
          {
            "label": "Klep sterk schuin",
            "code": "D",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17739966447112.png"
          },
          {
            "label": "Recht ingezette zak",
            "code": "D1",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17739966484402.png"
          }
        ]
      },
      {
        "key": "bandplooi",
        "label": "Bandplooi",
        "required": true,
        "values": [
          {
            "label": "Zonder bandplooi",
            "code": null,
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17788488009001.png"
          },
          {
            "label": "Met bandplooi",
            "code": null,
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17788487835460.png"
          }
        ]
      },
      {
        "key": "broekafwerking",
        "label": "Broekafwerking",
        "required": true,
        "values": [
          {
            "label": "Pantalon met rechte zoom",
            "code": null,
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17786887620466.png"
          },
          {
            "label": "Pantalon met omslagzoom",
            "code": null,
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17786887667893.png"
          }
        ]
      }
    ],
    "textSteps": [
      {
        "key": "aanvullende_wensen_colbert",
        "label": "Aanvullende wensen colbert"
      },
      {
        "key": "aanvullende_wensen_pantalon",
        "label": "Aanvullende wensen pantalon"
      }
    ]
  },
  "tuscany-db-dark-blue-banda-suit": {
    "title": "Tuscany DB Dark Blue Banda Suit",
    "price": 749,
    "swatchSteps": [
      {
        "key": "voering",
        "label": "Voering",
        "required": true,
        "values": [
          {
            "label": "Sky Blue Satin",
            "code": "DB_S21",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17745947819839.png"
          },
          {
            "label": "Midnight Navy",
            "code": "DB_S18",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17745947854375.png"
          },
          {
            "label": "Navy Houndstooth",
            "code": "2927",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17745947883494.png"
          }
        ]
      },
      {
        "key": "knopen",
        "label": "Knopen",
        "required": true,
        "values": [
          {
            "label": "Midnight Classic",
            "code": "F311",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17745948177875.png"
          },
          {
            "label": "Deep Navy Pearl",
            "code": "154",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17745948201333.png"
          },
          {
            "label": "Galaxy Blue",
            "code": "T110",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17745948227146.png"
          }
        ]
      },
      {
        "key": "zakken",
        "label": "Zakken",
        "required": true,
        "values": [
          {
            "label": "Klep recht",
            "code": "A",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17739966384650.png"
          },
          {
            "label": "Klep schuin",
            "code": "B",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17739966419194.png"
          },
          {
            "label": "Klep sterk schuin",
            "code": "D",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17739966447112.png"
          },
          {
            "label": "Recht ingezette zak",
            "code": "D1",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17739966484402.png"
          }
        ]
      },
      {
        "key": "bandplooi",
        "label": "Bandplooi",
        "required": true,
        "values": [
          {
            "label": "Zonder bandplooi",
            "code": null,
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17788488009001.png"
          },
          {
            "label": "Met bandplooi",
            "code": null,
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17788487835460.png"
          }
        ]
      },
      {
        "key": "broekafwerking",
        "label": "Broekafwerking",
        "required": true,
        "values": [
          {
            "label": "Pantalon met rechte zoom",
            "code": null,
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17786886605315.png"
          },
          {
            "label": "Pantalon met omslagzoom",
            "code": null,
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17786886665099.png"
          }
        ]
      }
    ],
    "textSteps": [
      {
        "key": "aanvullende_wensen_colbert",
        "label": "Aanvullende wensen colbert"
      },
      {
        "key": "aanvullende_wensen_pantalon",
        "label": "Aanvullende wensen pantalon"
      }
    ],
    "_seededFrom": "tuscany-db-marine-banda-suit"
  },
  "tuscany-db-grigio-suit": {
    "title": "Tuscany DB Grigio Suit",
    "price": 749,
    "swatchSteps": [
      {
        "key": "voering",
        "label": "Voering",
        "required": true,
        "values": [
          {
            "label": "Cool Light Grey",
            "code": "926",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17751448728142.png"
          },
          {
            "label": "Dusty Blue",
            "code": "P4042",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17751448740712.png"
          },
          {
            "label": "Off White Grey",
            "code": "P4004",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17751448756013.png"
          }
        ]
      },
      {
        "key": "knopen",
        "label": "Knopen",
        "required": true,
        "values": [
          {
            "label": "Charcoal Grey",
            "code": "423",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17751450596164.png"
          },
          {
            "label": "Deep Black",
            "code": "F123",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17751450612813.png"
          },
          {
            "label": "Midnight Blue",
            "code": "160",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17751450631940.png"
          }
        ]
      },
      {
        "key": "zakken",
        "label": "Zakken",
        "required": true,
        "values": [
          {
            "label": "Klep recht",
            "code": "A",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17739966384650.png"
          },
          {
            "label": "Klep schuin",
            "code": "B",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17739966419194.png"
          },
          {
            "label": "Klep sterk schuin",
            "code": "D",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17739966447112.png"
          },
          {
            "label": "Recht ingezette zak",
            "code": "D1",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17739966484402.png"
          }
        ]
      },
      {
        "key": "bandplooi",
        "label": "Bandplooi",
        "required": true,
        "values": [
          {
            "label": "Zonder bandplooi",
            "code": null,
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17788488009001.png"
          },
          {
            "label": "Met bandplooi",
            "code": null,
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17788487835460.png"
          }
        ]
      },
      {
        "key": "broekafwerking",
        "label": "Broekafwerking",
        "required": true,
        "values": [
          {
            "label": "Pantalon met rechte zoom",
            "code": null,
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17786885646828.png"
          },
          {
            "label": "Pantalon met omslagzoom",
            "code": null,
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17786885681118.png"
          }
        ]
      }
    ],
    "textSteps": [
      {
        "key": "aanvullende_wensen_colbert",
        "label": "Aanvullende wensen colbert"
      },
      {
        "key": "aanvullende_wensen_pantalon",
        "label": "Aanvullende wensen pantalon"
      }
    ]
  },
  "tuscany-grigio-suit": {
    "title": "Tuscany Grigio Suit",
    "price": 649,
    "swatchSteps": [
      {
        "key": "voering",
        "label": "Voering",
        "required": true,
        "values": [
          {
            "label": "Off White Grey",
            "code": "P4004",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17751806086860.png"
          },
          {
            "label": "Powder Blue",
            "code": "P4042",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17751806102943.png"
          },
          {
            "label": "Cool Light Grey",
            "code": "920",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17751806125551.png"
          }
        ]
      },
      {
        "key": "knopen",
        "label": "Knopen",
        "required": true,
        "values": [
          {
            "label": "Charcoal Grey",
            "code": "423",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17751806782942.png"
          },
          {
            "label": "Deep Black",
            "code": "F123",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17751806800887.png"
          },
          {
            "label": "Midnight Blue",
            "code": "160",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17751806817672.png"
          }
        ]
      },
      {
        "key": "zakken",
        "label": "Zakken",
        "required": true,
        "values": [
          {
            "label": "Klep recht",
            "code": "A",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17739966384650.png"
          },
          {
            "label": "Klep schuin",
            "code": "B",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17739966419194.png"
          },
          {
            "label": "Klep sterk schuin",
            "code": "D",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17739966447112.png"
          },
          {
            "label": "Recht ingezette zak",
            "code": "D1",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17739966484402.png"
          }
        ]
      },
      {
        "key": "bandplooi",
        "label": "Bandplooi",
        "required": true,
        "values": [
          {
            "label": "Zonder bandplooi",
            "code": null,
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17788488009001.png"
          },
          {
            "label": "Met bandplooi",
            "code": null,
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17788487835460.png"
          }
        ]
      },
      {
        "key": "broekafwerking",
        "label": "Broekafwerking",
        "required": true,
        "values": [
          {
            "label": "Pantalon met rechte zoom",
            "code": null,
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17786884673835.png"
          },
          {
            "label": "Pantalon met omslagzoom",
            "code": null,
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17786884722628.png"
          }
        ]
      }
    ],
    "textSteps": [
      {
        "key": "aanvullende_wensen_colbert",
        "label": "Aanvullende wensen colbert"
      },
      {
        "key": "aanvullende_wensen_pantalon",
        "label": "Aanvullende wensen pantalon"
      }
    ]
  },
  "tuscany-dark-blue-suit": {
    "title": "Tuscany Dark Blue Suit",
    "price": 789,
    "swatchSteps": [
      {
        "key": "voering",
        "label": "Voering",
        "required": true,
        "values": [
          {
            "label": "Sky Blue Satin",
            "code": "DB_S21",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17745947819839.png"
          },
          {
            "label": "Midnight Navy",
            "code": "DB_S18",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17745947854375.png"
          },
          {
            "label": "Cream Beige",
            "code": "11",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17793686509337.png"
          }
        ]
      },
      {
        "key": "knopen",
        "label": "Knopen",
        "required": true,
        "values": [
          {
            "label": "Midnight Classic",
            "code": "F311",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17745948177875.png"
          },
          {
            "label": "Deep Navy Pearl",
            "code": "154",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17745948201333.png"
          },
          {
            "label": "Galaxy Blue",
            "code": "T110",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17745948227146.png"
          }
        ]
      },
      {
        "key": "zakken",
        "label": "Zakken",
        "required": true,
        "values": [
          {
            "label": "Klep recht",
            "code": "A",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17739966384650.png"
          },
          {
            "label": "Klep schuin",
            "code": "B",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17739966419194.png"
          },
          {
            "label": "Klep sterk schuin",
            "code": "D",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17739966447112.png"
          },
          {
            "label": "Recht ingezette zak",
            "code": "D1",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17739966484402.png"
          }
        ]
      },
      {
        "key": "bandplooi",
        "label": "Bandplooi",
        "required": true,
        "values": [
          {
            "label": "Zonder bandplooi",
            "code": null,
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17788488009001.png"
          },
          {
            "label": "Met bandplooi",
            "code": null,
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17788487835460.png"
          }
        ]
      },
      {
        "key": "broekafwerking",
        "label": "Broekafwerking",
        "required": true,
        "values": [
          {
            "label": "Pantalon met rechte zoom",
            "code": null,
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17786883749815.png"
          },
          {
            "label": "Pantalon met omslagzoom",
            "code": null,
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17786883792429.png"
          }
        ]
      }
    ],
    "textSteps": [
      {
        "key": "aanvullende_wensen_colbert",
        "label": "Aanvullende wensen colbert"
      },
      {
        "key": "aanvullende_wensen_pantalon",
        "label": "Aanvullende wensen pantalon"
      }
    ]
  },
  "tuscany-db-marine-banda-suit": {
    "title": "Tuscany DB Marine Banda Suit",
    "price": 749,
    "swatchSteps": [
      {
        "key": "voering",
        "label": "Voering",
        "required": true,
        "values": [
          {
            "label": "Sky Blue Satin",
            "code": "DB_S21",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17745947819839.png"
          },
          {
            "label": "Midnight Navy",
            "code": "DB_S18",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17745947854375.png"
          },
          {
            "label": "Navy Houndstooth",
            "code": "2927",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17745947883494.png"
          }
        ]
      },
      {
        "key": "knopen",
        "label": "Knopen",
        "required": true,
        "values": [
          {
            "label": "Midnight Classic",
            "code": "F311",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17745948177875.png"
          },
          {
            "label": "Deep Navy Pearl",
            "code": "154",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17745948201333.png"
          },
          {
            "label": "Galaxy Blue",
            "code": "T110",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17745948227146.png"
          }
        ]
      },
      {
        "key": "zakken",
        "label": "Zakken",
        "required": true,
        "values": [
          {
            "label": "Klep recht",
            "code": "A",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17739966384650.png"
          },
          {
            "label": "Klep schuin",
            "code": "B",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17739966419194.png"
          },
          {
            "label": "Klep sterk schuin",
            "code": "D",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17739966447112.png"
          },
          {
            "label": "Recht ingezette zak",
            "code": "D1",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17739966484402.png"
          }
        ]
      },
      {
        "key": "bandplooi",
        "label": "Bandplooi",
        "required": true,
        "values": [
          {
            "label": "Zonder bandplooi",
            "code": null,
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17788488009001.png"
          },
          {
            "label": "Met bandplooi",
            "code": null,
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17788487835460.png"
          }
        ]
      },
      {
        "key": "broekafwerking",
        "label": "Broekafwerking",
        "required": true,
        "values": [
          {
            "label": "Pantalon met rechte zoom",
            "code": null,
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17786886605315.png"
          },
          {
            "label": "Pantalon met omslagzoom",
            "code": null,
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17786886665099.png"
          }
        ]
      }
    ],
    "textSteps": [
      {
        "key": "aanvullende_wensen_colbert",
        "label": "Aanvullende wensen colbert"
      },
      {
        "key": "aanvullende_wensen_pantalon",
        "label": "Aanvullende wensen pantalon"
      }
    ]
  },
  "tuscany-db-sand-banda-suit": {
    "title": "Tuscany DB Sand Banda Suit",
    "price": 749,
    "swatchSteps": [
      {
        "key": "voering",
        "label": "Voering",
        "required": true,
        "values": [
          {
            "label": "Silver Grey Satin",
            "code": null,
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17745951625990.png"
          },
          {
            "label": "Ivory Essential",
            "code": "NAT",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17737587322446.png"
          },
          {
            "label": "Champagne Satin",
            "code": "F122",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17745951687707.png"
          }
        ]
      },
      {
        "key": "knopen",
        "label": "Knopen",
        "required": true,
        "values": [
          {
            "label": "Dark Walnut Gloss",
            "code": null,
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17745951893552.png"
          },
          {
            "label": "Ivory Classic",
            "code": null,
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17737587733327.png"
          },
          {
            "label": "Amber Marble",
            "code": null,
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17745951913208.png"
          }
        ]
      },
      {
        "key": "zakken",
        "label": "Zakken",
        "required": true,
        "values": [
          {
            "label": "Klep recht",
            "code": "A",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17739966384650.png"
          },
          {
            "label": "Klep schuin",
            "code": "B",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17739966419194.png"
          },
          {
            "label": "Klep sterk schuin",
            "code": "D",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17739966447112.png"
          },
          {
            "label": "Recht ingezette zak",
            "code": "D1",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17739966484402.png"
          }
        ]
      },
      {
        "key": "bandplooi",
        "label": "Bandplooi",
        "required": true,
        "values": [
          {
            "label": "Zonder bandplooi",
            "code": null,
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17788488009001.png"
          },
          {
            "label": "Met bandplooi",
            "code": null,
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17788487835460.png"
          }
        ]
      },
      {
        "key": "broekafwerking",
        "label": "Broekafwerking",
        "required": true,
        "values": [
          {
            "label": "Pantalon met rechte zoom",
            "code": null,
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17786859560067.png"
          },
          {
            "label": "Pantalon met omslagzoom",
            "code": null,
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17786859641399.png"
          }
        ]
      }
    ],
    "textSteps": [
      {
        "key": "aanvullende_wensen_colbert",
        "label": "Aanvullende wensen colbert"
      },
      {
        "key": "aanvullende_wensen_pantalon",
        "label": "Aanvullende wensen pantalon"
      }
    ]
  },
  "tuscany-grey-suit": {
    "title": "Tuscany Grey Suit",
    "price": 649,
    "swatchSteps": [
      {
        "key": "voering",
        "label": "Voering",
        "required": true,
        "values": [
          {
            "label": "Cool Light Grey",
            "code": "926",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17751448728142.png"
          },
          {
            "label": "Dusty Blue",
            "code": "P4042",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17751448740712.png"
          },
          {
            "label": "Off White Grey",
            "code": "P4004",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17751448756013.png"
          }
        ]
      },
      {
        "key": "knopen",
        "label": "Knopen",
        "required": true,
        "values": [
          {
            "label": "Charcoal Grey",
            "code": "423",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17751450596164.png"
          },
          {
            "label": "Deep Black",
            "code": "F123",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17751450612813.png"
          },
          {
            "label": "Midnight Blue",
            "code": "160",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17751450631940.png"
          }
        ]
      },
      {
        "key": "zakken",
        "label": "Zakken",
        "required": true,
        "values": [
          {
            "label": "Klep recht",
            "code": "A",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17739966384650.png"
          },
          {
            "label": "Klep schuin",
            "code": "B",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17739966419194.png"
          },
          {
            "label": "Klep sterk schuin",
            "code": "D1",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17739966447112.png"
          },
          {
            "label": "Recht ingezette zak",
            "code": "D1",
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17739966484402.png"
          }
        ]
      },
      {
        "key": "bandplooi",
        "label": "Bandplooi",
        "required": true,
        "values": [
          {
            "label": "Zonder bandplooi",
            "code": null,
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17788488009001.png"
          },
          {
            "label": "Met bandplooi",
            "code": null,
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17788487835460.png"
          }
        ]
      },
      {
        "key": "broekafwerking",
        "label": "Broekafwerking",
        "required": true,
        "values": [
          {
            "label": "Pantalon met rechte zoom",
            "code": null,
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17786088139963.png"
          },
          {
            "label": "Pantalon met omslagzoom",
            "code": null,
            "image": "https://www.mscvtr.com/cdn/shop/files/swatch-17786088224705.png"
          }
        ]
      }
    ],
    "textSteps": [
      {
        "key": "aanvullende_wensen_colbert",
        "label": "Aanvullende wensen colbert"
      },
      {
        "key": "aanvullende_wensen_pantalon",
        "label": "Aanvullende wensen pantalon"
      }
    ]
  }
};
